// Checkout form rules. Mirrors backend/src/utils/validateShipping.js.

import { isValidPhone as isValidPhoneNumber } from "./phone";

const EMAIL_RE = /^[^\s@]+@[^\s@]+\.[^\s@]{2,}$/;

export const EMAIL_MAX_LENGTH = 254;
export const PHONE_MAX_LENGTH = 16;

export const isValidEmail = (value) =>
    typeof value === "string" && value.length <= EMAIL_MAX_LENGTH && EMAIL_RE.test(value.trim());

/** Per-country check (length and number ranges) of an E.164 number. */
export const isValidPhone = (value) => isValidPhoneNumber(value);

/** Keeps a leading "+" and digits only, capped at E.164 length. */
export const sanitizePhone = (value) => {
    const digits = String(value || "").replace(/\D/g, "").slice(0, PHONE_MAX_LENGTH - 1);
    return `+${digits}`;
};
